// import React, { useEffect, useState } from "react";

// function WebSocketComponent() {
//     const [messages, setMessages] = useState([]);

//     useEffect(() => {
//         const wsUrl = "npm";
//         const ws = new window.WebSocket(wsUrl);

//         ws.onopen = () => {
//             console.log("Connected to WebSocket server");
//             ws.send("Hello from React!");
//         };

//         ws.onmessage = (event) => {
//             console.log("Message from server:", event.data);
//             setMessages((prevMessages) => [...prevMessages, event.data]);
//         };

//         ws.onclose = () => {
//             console.log("Disconnected from WebSocket server");
//         };

//         ws.onerror = (error) => {
//             console.error("WebSocket error:", error);
//         };

//         return () => {
//             ws.close();
//         };
//     }, []);

//     return (
//         <div className="App">
//             <h1>WebSocket Messages</h1>
//             <ul>
//                 {messages.map((msg, index) => (
//                     <li key={index}>{msg}</li>
//                 ))}
//             </ul>
//         </div>
//     );
// }

// export default WebSocketComponent;
